<template>
  <b-container fluid>
    <b-row class="my-3">
      <b-col md="6">
        <h4>Contracts</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-table outlined
                 hover
                :items="contracts"
                thead-class="hidden"
                id="contractsTable"
                @row-clicked="goToContractDetails">
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ContractsProvider from '@/services/ContractsProvider'

export default {
  name: 'VendorDetails',
  data () {
    return {
      contracts: []
    }
  },
  mounted () {
    ContractsProvider.all({ vendorId: this.$route.params.id }).then(resp => {
      this.contracts = resp.body.contracts
    })
  },
  methods: {
    goToContractDetails (contract) {
      this.$router.push({ name: 'ContractDetails',
        params: {
          vendor_id: this.$route.params.id,
          uuid: contract.uuid
        }
      })
    }
  }
}
</script>

<style>
  #contractsTable tr:hover {
    cursor: pointer;
  }
</style>
